/**
 * Shipping Restrictions Configuration
 * Update this file to add/remove blocked states or ZIP prefixes.
 */

export interface ZipRestriction {
  prefix: string;
  locality: string;
}

export const BLOCKED_STATES: Record<string, string> = {
  AL: "Alabama",
  AR: "Arkansas",
  IN: "Indiana",
  RI: "Rhode Island",
  VT: "Vermont",
  WI: "Wisconsin",
};

export const BLOCKED_ZIP_PREFIXES: ZipRestriction[] = [
  { prefix: "342", locality: "Sarasota County, FL" },
  { prefix: "921", locality: "San Diego, CA" },
];

/**
 * Returns the restricted location name if the state is blocked, otherwise null.
 */
export function getBlockedState(stateCode: string): string | null {
  if (!stateCode) return null;
  return BLOCKED_STATES[stateCode.toUpperCase()] ?? null;
}

/**
 * Returns the restricted locality name if the ZIP prefix is blocked, otherwise null.
 */
export function getBlockedZip(zip: string): string | null {
  if (!zip) return null;
  const match = BLOCKED_ZIP_PREFIXES.find((r) => zip.startsWith(r.prefix));
  return match ? match.locality : null;
}
